import styled from 'styled-components/macro';

const Input = styled.input`
  border: 2px solid var(--coolGray-300);
  padding: 0.5rem 0.75rem;
  border-radius: 0.6rem / 0.55rem;
  color: var(--color-text);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.04);
  resize: vertical;
  font-size: var(--font-size-1);
  transition: border-color 200ms ease-in-out, box-shadow 200ms ease-in-out;
  ::placeholder {
    color: #b0b9cd;
  }

  &:not([disabled]):focus,
  &:not([disabled]):active {
    border-color: var(--color-primary);
  }

  &:not([disabled]):focus-visible {
    box-shadow: 0 0 0px 2px rgba(255, 255, 255, 0.5),
      0 0 1px 3px var(--indigo-200);
  }
`;
export default Input;
